<template>
  <div class="userMenu">
    <notice />

    <div class="icons">
      <el-badge :value="unreadCount" class="badge" :hidden="unreadCount === 0">
        <div class="img3" @click="setNoticeVisible(true)"></div>
      </el-badge>
      <div class="img2" @click="$utils.help()"></div>
      <!-- <img src="@/assets/image/home/header/icon_1.webp" alt=""  /> -->
      <div class="img" @click="setServicepopupvisible({ visible: true })"></div>
      <!-- <img src="@/assets/image/home/header/icon_2.webp" alt="" @click="setServicepopupvisible(true)"/> -->
    </div>
    <div class="solid"></div>
    <div class="user" @click="setUserDrawerShow(true)">
      <img
        src="@/assets/image/home/header/icon_4.webp"
        alt=""
        v-if="authType === 'allAuth'"
      />
      <img
        src="@/assets/image/home/header/icon_3.webp"
        v-if="authType === 'unCompanyAuth'"
      />
      <img src="@/assets/image/home/header/icon_7.webp" v-if="authType === 'unAuth'" />
      <div class="username">{{ user.name }}</div>
      <el-icon color="#999999"><CaretBottom /></el-icon>
    </div>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import { mapState, mapMutations, mapActions,mapGetters } from "vuex";
import notice from "@/components/notice/notice.vue";
export default {
  mixins: [userinfo],
  components: {
    notice,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters("notice", ["unreadCount"]),
  },
  methods: {
    ...mapActions("app", ["setUserDrawerShow", "setServicepopupvisible"]),
    ...mapActions("notice", ["setNoticeVisible"]),
  },
};
</script>

<style scoped lang="scss">
.userMenu {
  display: flex;
  gap: 20px;

  .icons {
    display: flex;
    gap: 30px;
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .img,
    .img2,
    .img3 {
      width: 18px;
      height: 18px;
      cursor: pointer;
      background-image: url(~@/assets/image/home/header/icon_9.webp);
      background-size: 100% 100%;
      &:hover {
        background-image: url(~@/assets/image/home/header/icon_2.webp);
        background-size: 100% 100%;
      }
    }
    .img2 {
      background-image: url(~@/assets/image/home/header/icon_1.webp);
      &:hover {
        background-image: url(~@/assets/image/home/header/icon_8.webp);
        background-size: 100% 100%;
      }
    }
    .img3 {
      background-image: url(~@/assets/image/home/header/icon_10.webp);
      &:hover {
        background-image: url(~@/assets/image/home/header/icon_11.webp);
        background-size: 100% 100%;
      }
    }
    &::v-deep .el-badge {
      &__content {
        background-color: #ff0d0d;
        border: none;
      }
    }
  }
  .solid {
    width: 1px;
    height: 16px;
    background: #99a7ba;
  }
  .user {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    img {
      width: 12px;
      height: 14px;
    }
    .username {
      font-family: "Noto Sans SC";
      font-size: 14px;
      color: #3d3d3d;
      white-space: nowrap; // 强制不换行
    }
  }
}
</style>
